<template>
  <div class="donate">

   <Header/>
    <h3>Klaar om te doneren?</h3>
     <nav>
        <router-link :to="{ name: 'Donate_step1' }"><button>Snel doneren</button></router-link>
        <router-link :to="{ name: 'Donator_step1' }"><button>Donateur worden</button></router-link>
      </nav>
      <img src="http://rubendeman.nl/rubendeman.nl//afstuderen/test/" width="200px" alt="">
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: 'Donate',
  components: { Header },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/more_info/donate.vue